export class MetricsService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
        this.BASE_URI = '/metrics';
        this.INTERVAL_DAILY = 'D';
        this.INTERVAL_MONTHLY = 'M';
        this.INTERVAL_NO_INERVAL = 'NI';
        this.toUrl = 'postmaster@analytics.msging.net';
    }
    async getUserStatistics(interval, startDate, endDate) {
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'get',
            to: this.toUrl,
            uri: `${this.BASE_URI}/engaged-identity/${interval}?startDate=${startDate}&endDate=${endDate}`,
        });
        return this.MessagingHubService.ensureCommandSuccess(commandResponse).resource;
    }
    async getSentMessagesStatistics(interval, startDate, endDate) {
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'get',
            to: this.toUrl,
            uri: `${this.BASE_URI}/sent-messages/${interval}?startDate=${startDate.toString()}&endDate=${endDate.toString()}`,
        });
        return this.MessagingHubService.ensureCommandSuccess(commandResponse).resource;
    }
    async getReceivedMessagesStatistics(interval, startDate, endDate) {
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'get',
            to: this.toUrl,
            uri: `${this.BASE_URI}/received-messages/${interval}?startDate=${startDate.toString()}&endDate=${endDate.toString()}`,
        });
        return this.MessagingHubService.ensureCommandSuccess(commandResponse).resource;
    }
}
MetricsService.$inject = ['MessagingHubService'];
